import { useEffect } from 'react';
import calendaricon from '../../images/vector_x2.svg'
import axios from 'axios';
import '../ResponsiveEvent.jsx/RequestHeader.css';
import useFormContext from "./useFormMarsComplete"
import defaultBackgroundImage from "../../images/capture_decran_20240313_a_16271.jpg";
import { EVENT_COVER_URL } from '../ApiDetails.js';

export default function RequestHeader() {
    const { eventFormData } = useFormContext()

    // Event id is the last item in URL.
    const eventID = location.pathname.split('/').pop();

    useEffect(() => {
        const fetchEventDetails = async () => {
            var hdrDiv = document.getElementById("hdrDiv");

            await axios.get(`${EVENT_COVER_URL}/${eventID}`)
                .then(response => {
                    // Set background image based on cover image availability
                    if (response.data === '') {
                        hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                    } else {
                        hdrDiv.style.backgroundImage = `url(${response.data})`;
                    }
                })
                .catch(error => {
                    console.error("Error fetching event details:", error);
                    hdrDiv.style.backgroundImage = `url(${defaultBackgroundImage})`;
                });
        };

        // Don't retrieve event during creation.
        if (eventID !== "create") {
            fetchEventDetails();
        }
    }, [eventFormData.eventId]);

    return (
        <div className="requestHeader">
            <div className="container-fluid">
                <div id='hdrDiv' className="bd-placeholder-img custom-jumbotron jumbotron p-6 mt-3 p-md-3 text-white rounded mb-2 d-flex flex-column justify-content-end m-4" >
                    <div className="row bottom-row ml-2 mr-2">
                        <div className="col-12 col-md-8 p-2 px-0 bg-light rounded mb-5 mb-md-0 ">
                            <div className="content">
                                <h6>
                                    <input
                                        type="text"
                                        readOnly={true}
                                        className="custom-title form-control-plaintext disabled"
                                        id="staticEmail"
                                        name="eventTitle"
                                        value={eventFormData.eventTitle}
                                        placeholder="Click here to modify the event"
                                        style={{ backgroundColor: 'white !important', fontWeight: 'bold !important', fontSize: '60% !important' }}
                                    />
                                </h6>
                                <p>
                                    <strong>
                                        <img src={calendaricon} height='12px' />
                                    </strong>
                                    <span className='m-1'> <strong>Event date:  </strong> {new Date(eventFormData.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</span>

                                </p>
                                <span>Status</span>
                                <div className="breadcrumb btn-group btn-breadcrumb rounded" id="eventStatusTab">
                                    <a className="btn-custom btn btn-default selectbreadcrumb" id="Draft" style={{ pointerEvents: "none" }}>Draft</a>
                                    {(eventFormData.mltEvent === false || eventFormData.mltEvent === null) && (
                                        <><a className="btn-custom btn btn-default" id="UnderReview" style={{ pointerEvents: "none" }}>Under Review</a></>
                                    )}
                                    {(eventFormData.eventStatus === "Cancelled") && (
                                        <><a className="btn-custom btn btn-default" id="Cancelled" style={{ pointerEvents: "none" }}>Cancelled</a></>
                                    )}
                                    {(eventFormData.eventStatus === "Rejected") && (
                                        <><a className="btn-custom btn btn-default" id="Rejected" style={{ pointerEvents: "none" }}>Rejected</a></>
                                    )}
                                    {(eventFormData.eventStatus != "Cancelled") && (eventFormData.eventStatus != "Rejected") && (
                                        <>
                                            <a className="btn-custom btn btn-default" id="OpenEvent" style={{ pointerEvents: "none" }}>Open Event</a>
                                            <a className="btn-custom btn btn-default" id="AttendanceConfirmed" style={{ pointerEvents: "none" }}>Attendance confirmed</a>
                                            <a className="btn-custom btn btn-default" id="PendingDocumentation" style={{ pointerEvents: "none" }}>Pending documentation</a>
                                            <a className="btn-custom btn btn-default" id="Completed" style={{ pointerEvents: "none" }}>Completed</a>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}